import {Component, Input} from '@angular/core';
import {Clipboard} from '@angular/cdk/clipboard';
import {UploadFileErrorColumns} from '../../../../models/validation-upload-file-errors';

@Component({
    selector: 'app-upload-file-errors',
    templateUrl: './upload-file-errors.component.html',
    styleUrls: ['./upload-file-errors.component.less']
})
export class UploadFileErrorsComponent {
    @Input() errors: any[] = [];
    @Input() columns: UploadFileErrorColumns[] = [];
    constructor(private clipboard: Clipboard) {
    }

    copyToClipboard() {
        const copyText = this.errors?.map(
            error => this.columns?.map(column => error[column?.fieldName]).join(';')
        ).join('\n');
        this.clipboard.copy(copyText);
    }
}
